<div>
    <app-vwsa-text text="Vehicle and Current Plan Details" weight="bold"></app-vwsa-text>
    <br />

    <div class="column__list">
        <div class="card__list">
            <app-vwsa-text-input inputId="select-plan-vehicleModel" label="Vehicle Model" value="{{selectedVehicleDetail?.modelDescription}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="select-plan-year" label="Model Year" value="{{selectedVehicleDetail?.year}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="select-plan-odometerReading" label="Odometer Reading" value="{{selectedVehicleDetail?.currentOdometer}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="select-plan-currentPlanType" label="Current Plan Type" value="{{selectedVehicleDetail?.planType}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <div [hidden]="isPlanTypeUnknown">
                <app-vwsa-text-input inputId="select-plan-currentPlanYears" label="Current Plan Years" value="{{selectedVehicleDetail?.currentPlanYears}}" disabled="true">
                </app-vwsa-text-input>
            </div>
        </div>
        <div class="card__list">
            <div [hidden]="isPlanTypeUnknown">
                <app-vwsa-text-input inputId="select-plan-currentPlanDistance" label="Current Plan Distance" value="{{selectedVehicleDetail?.currentPlanEndKM}}" disabled="true">
                </app-vwsa-text-input>
            </div>
        </div>
        <div class="card__list" [hidden]="justBrowsing">
            <app-vwsa-text-input inputId="select-plan-warrantyStatus" label="Warranty" value="{{selectedVehicleDetail?.warrantyStatus}}" disabled="true">
            </app-vwsa-text-input>
        </div>
    </div>

    <div [hidden]="!isPlanTypeUnknown">
        <app-vwsa-text text="The Standard Plan of this Vehicle has been assumed."></app-vwsa-text><br />
    </div>

    <app-vwsa-text text="Recommended New Plan Options" weight="bold"></app-vwsa-text><br />
    <div class="column__list">
        <div class="card__list" *ngFor="let npo of newPlanOptions">
            <app-new-plan-option [data]="npo"></app-new-plan-option>
        </div>
    </div>
    <div [hidden]="newPlanOptions?.length>0">
        <app-vwsa-text text="We couldn't find any recommended plans for your vehicle."></app-vwsa-text>
        <br />
    </div>

    <app-customize-plan #customizePlan></app-customize-plan>

    <br />
    <app-vwsa-text text="EasyDrive Plan Types" weight="bold"></app-vwsa-text><br />

    <div class="column__list">
        <div class="card__list" style="border-bottom:1.5px solid #001E50;height:100%;">
            <div>
                <app-vwsa-text text="Warranty Plan" weight="bold"></app-vwsa-text><br />
                <app-vwsa-text text="{{contentTexts | ContentText:'WarrantyPlanDetails'}}"></app-vwsa-text>
            </div>
        </div>
        <div class="card__list" style="border-bottom:1.5px solid #001E50;height:100%;">
            <div>
                <app-vwsa-text text="EasyDrive Service Plan" weight="bold"></app-vwsa-text><br />
                <app-vwsa-text text="{{contentTexts | ContentText:'ServicePlanDetails'}}"></app-vwsa-text>
            </div>
        </div>
        <div class="card__list" style="border-bottom:1.5px solid #001E50;height:100%;">
            <div>
                <app-vwsa-text text="EasyDrive Maintenance Plan" weight="bold"></app-vwsa-text><br />
                <app-vwsa-text text="{{contentTexts | ContentText:'MaintenancePlanDetails'}}"></app-vwsa-text>
            </div>
        </div>
    </div>

    <div *ngIf="justBrowsing">
        <br /><br />
        <app-vwsa-text text="{{contentTexts | ContentText:'Disclaimer'}}" appearance="copy0200" color="secondary">
        </app-vwsa-text>
        <br />
    </div>

    <br />
    <app-vwsa-button text="Back" (click)="onBackToCustomerDetails()" variant="secondary"></app-vwsa-button>
</div>